import React, { Component } from "react";
import { connect } from "react-redux";
import {
  clearSystemFeedbacks,
  deleteAdminSystemFeedbacks,
  getAdminSystemFeedbacks,
} from "../../../actions/webinars";
import TablePagination from "components/Pagination/TablePagination";
import IconButton from "material-ui/IconButton";
import Menu, { MenuItem } from "material-ui/Menu";
import MoreVertIcon from "material-ui-icons/MoreVert";

import { push } from "redux-router";

const headers = ["User name", "Body"];

class SystemFeedbacks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      per_page: 10,
      selected: [],
      anchorEl: null,
    };
  }

  componentDidMount() {
    this.getFeedbacks();
  }

  componentWillUnmount() {
    this.props.clearSystemFeedbacks();
  }

  getFeedbacks() {
    const { page, per_page } = this.state;
    this.props.getSystemFeedback({ page, per_page });
  }

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.getFeedbacks
    );
  };

  handleDelete = (selected) => {
    this.props.deleteSystemFeedbacks({ ...this.state, selected });
  };

  handleSelect = (id) => {
    this.state.selected.includes(id)
      ? this.setState({ selected: this.state.selected.filter((s) => s !== id) })
      : this.setState({ selected: [...this.state.selected, id] });
  };

  render() {
    const { data, count, totalPages } = this.props.feedbacks;
    const { page, selected } = this.state;

    return (
      <main className="site--width ">
        <div className="admin_list">
          <h5>Feedbacks({count})</h5>
          <a
            className="button_classic"
            onClick={this.props.navigateToAddFeedback}
          >
            Add feedback
          </a>
          <a
            className="button_delete"
            onClick={() => this.handleDelete(this.state.selected)}
          >
            Delete
          </a>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              {headers.map((v, idx) => (
                <th key={idx}>{v}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map(({ body, user_name, id }) => (
              <tr key={id}>
                <td>
                  <p>
                    <input
                      type="checkbox"
                      className="filled-in"
                      id="filled-in-box10"
                      checked={selected.includes(id)}
                      key={id}
                    />
                    <label
                      for="filled-in-box10"
                      onClick={() => this.handleSelect(id)}
                    ></label>
                  </p>
                </td>
                <td>{user_name}</td>
                <td>{body}</td>
                <Actions
                  id={id}
                  handleDelete={this.handleDelete}
                  navigateToEditFeedback={this.props.navigateToEditFeedback}
                />
              </tr>
            ))}
          </tbody>
        </table>
        <TablePagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={totalPages}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    feedbacks: state.webinars.systemFeedbacks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSystemFeedback: (params) => dispatch(getAdminSystemFeedbacks(params)),
    clearSystemFeedbacks: () => dispatch(clearSystemFeedbacks()),
    deleteSystemFeedbacks: (payload) =>
      dispatch(deleteAdminSystemFeedbacks(payload)),
    navigateToAddFeedback: () => dispatch(push(`/feedbacks/new`)),
    navigateToEditFeedback: (id) => dispatch(push(`/feedbacks/${id}`)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemFeedbacks);

class Actions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const ITEM_HEIGHT = 48;

    const { anchorEl } = this.state;
    const { navigateToEditFeedback, handleDelete, id } = this.props;

    return (
      <td>
        <IconButton
          className="table_more"
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          }}
        >
          <MenuItem onClick={() => navigateToEditFeedback(id)}>Edit</MenuItem>
          <MenuItem onClick={() => handleDelete([id])}>Delete</MenuItem>
        </Menu>
      </td>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Admin/SystemFeedbacks/index.jsx